import Vue from "vue";
import { HealthService } from "@lab/types/healthservice";
import * as api from "@lab/api/health.service.api";
import { getUsers } from "@lab/api/hospitals.api";
import { User } from "@/shared/types/users";
import { stat } from "fs";
const state = {
	byID: [],
	usersByID: [],
	isFetching: false,
	errorMessage: null,
	lastFetched: null // Timestamp
};
const getters = {
	getHealthServices: (state): HealthService[] =>
		state.byID ? Object.values(state.byID) : null,
	getHealthService:
		(state: any) =>
		(id: number): HealthService => {
			return state.byID[id];
		},
	getHealthServiceUsers: (state: any): User[] =>
		state.usersByID ? Object.values(state.usersByID) : null,
	IsFetching: (state): boolean => state.isFetching,
	error: (state): string => state.errorMessage
};
const actions = {
	async fetchHealthServices({ commit }) {
		try {
			commit("LOAD_START");
			const response = await api.getHealthServices();
			commit("LOAD_LIST_SUCCESS", response);
		} catch (error) {
			// handle the error here
		}
	},
	async fetchHealthService({ commit }, id: number) {
		// Do we already have the user?
		/**
		 * @TODO: need to think this logic through a little more
		 * before we implement it
		 */
		// if (getters.getHealthService(id)) return;

		commit(`LOAD_START`);
		// get the base health service object
		const healthservice = await api.getHealthService(id);

		const users = await api.getUsers(id);

		healthservice.users = users || [];

		const groups = await api.getGroups(id);

		groups.forEach((group) => {
			group.hospital = healthservice.hospitals.find(
				(hospital) => hospital.id === group.hospitalid
			);
		});

		healthservice.groups = groups;

		// Save the hospital to the VUEX state.
		commit(`LOAD_ITEM_SUCCESS`, healthservice);
	},
	async deleteHealthService({ commit }, id: number) {
		try {
			await api.remove(id);
			commit("DELETE_ITEM_SUCCESS", id);
		} catch (error) {
			console.log(error);
			throw error;
		}
	},
	async updateHealthService({ commit }, healthservice: HealthService) {
		const response = await api.update(healthservice);

		commit(`UPDATE_ITEM_SUCCESS`, response);
	},
	async create({ commit }, healthservice: HealthService) {
		const response = await api.create(healthservice);
		commit("CREATE_ITEM_SUCCESS", response);
		return response;
	}
};
const mutations = {
	LOAD_LIST_SUCCESS(state: any, healthservices: HealthService[]) {
		const byID = healthservices.reduce((acc, val) => {
			acc[val.id] = val;
			return acc;
		}, {});
		Vue.set(state, "byID", byID);
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_ITEM_SUCCESS(state: any, healthservice: HealthService) {
		if (!healthservice) return;
		Vue.set(state.byID, healthservice.id.toString(), healthservice);
		state.isFetching = false;
	},
	UPDATE_ITEM_SUCCESS(state: any, healthservice: HealthService) {
		const { id } = healthservice;
		const updated = { ...state.byID[id], ...healthservice };
		Vue.set(state.byID, healthservice.id, updated);
	},
	CREATE_ITEM_SUCCESS(state: any, healthservice: HealthService) {
		Vue.set(state.byID, healthservice.id.toString(), healthservice);
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	},
	DELETE_ITEM_SUCCESS(state: any, id: number) {
		Vue.delete(state.byID, id);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
